module.exports = __webpack_public_path__ + "media/images/soar/site/bg_top_create-2c2fc0039f099fd7d4412f8a496b0523.svg";